import { Dto, DtoWithId } from '@mango/core';
import { Personeel } from '../core/dto/personeel';
import { Relatie } from '../core/dto/relatie';

@Dto({fullName: "CIJBorculo.Logic.User",archivable:true})
export class User extends DtoWithId {
    // code: number;
    email: string;
    //activeDirectoryUserName: string;
    firstName: string;
    lastName: string;
    name: string;
    personeel: Personeel;
    werkbonPrinter: string;
    pakbonPrinter: string;
    factuurPrinter: string;
    stickerPrinter: string;
    certificaatVoorbladPrinter : string;
	certificaatVolgbladPrinter : string;
    algemenePrinter: string;
    hasRelaties:boolean;
    relaties: string;
    meetInstrumenten: boolean;
    energie: boolean;
    archivedOn: Date;
    certificaatSignatureFile: string;
    certificaatSignatureName: string;
    lastLogin: Date;
    locked: boolean;
    lastPasswordChanged: Date;
    mfaEnabled: boolean;
    isMfaExempt: boolean;
    internalLogin: boolean;
}